module.exports = __webpack_public_path__ + "img/main.1b56107f.jpg";